// Frittstående ORBAT-creator (poppet ut til egen skjerm). Deler samme motor og
// localStorage-tilstand som docked-visningen; redigeringer distribueres via
// hubbens collab-kanal (type 'orbat') slik at flere skjermer holdes i synk.
import { OrbatEventSchema } from '@skade/contracts';
import type { User } from '@skade/rbac';
import type { Feed } from '../data/feed.js';
import type { SyncBus } from '../sync.js';
import { OrbatCreator } from '../ui/orbat-creator.js';

export function mountOrbatPanel(root: HTMLElement, feed: Feed, _sync: SyncBus, user: User): void {
  document.body.classList.add('panel-standalone');
  root.innerHTML = '';
  const wrap = document.createElement('div');
  wrap.className = 'standalone-panel';
  const head = document.createElement('div');
  head.className = 'standalone-head';
  head.append(span('brand', 'SKADE'), span('standalone-title', 'ORBAT-creator'));
  wrap.append(head);

  const creator = new OrbatCreator({
    user,
    embedded: true,
    onEvent: (ev) => feed.send?.({ type: 'orbat', orbat: ev }),
  });
  wrap.append(creator.el);
  root.append(wrap);

  feed.onCollab?.((m) => {
    if (m.kind === 'orbat' && m.orbat) {
      const ev = OrbatEventSchema.safeParse(m.orbat);
      if (ev.success) creator.ingestEvent(ev.data);
    }
  });
  feed.start();
}

function span(cls: string, text: string): HTMLElement { const e = document.createElement('span'); e.className = cls; e.textContent = text; return e; }
